var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import PurchaseService from '../../../api/PurchaseService';
import GoodService from '../../../api/GoodService';
var initFormData = {
    organ_id: '',
    depot_id: '',
    goods_type_id: null,
    keyword: '',
};
var DetailHeader = (function (_super) {
    __extends(DetailHeader, _super);
    function DetailHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.supplierorganOptions = [];
        _this.supplierdepotOptions = [];
        _this.categoryData = [];
        return _this;
    }
    DetailHeader.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    DetailHeader.prototype.watchFormDataOrganId = function (newVal, oldVal) {
        this.getSupplierdepotOptions();
    };
    DetailHeader.prototype.created = function () {
        this.purchaseService = PurchaseService.getInstance();
        this.goodService = GoodService.getInstance();
        this.getSupplierorganOptions();
        this.getSupplierdepotOptions();
        this.getCategory();
    };
    DetailHeader.prototype.getCategory = function () {
        var _this = this;
        this.goodService.getCategory().then(function (res) {
            _this.categoryData = res.data.data;
        });
    };
    DetailHeader.prototype.getSupplierorganOptions = function () {
        var _this = this;
        this.purchaseService.getSupplierorganOptions().then(function (res) {
            _this.supplierorganOptions = [{ organ_id: '', organ_name: '全部机构' }].concat(res.data.data);
        });
    };
    DetailHeader.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id,
        };
        this.purchaseService.getSupplierdepotOptions(params).then(function (res) {
            _this.supplierdepotOptions = [{ depot_id: '', depot_name: '全部仓库' }].concat(res.data.data);
            var currentDepot = _this.supplierdepotOptions.some(function (item) { return item.depot_id === _this.formData.depot_id; });
            if (!currentDepot || !_this.formData.organ_id)
                _this.formData.depot_id = '';
        });
    };
    DetailHeader.prototype.search = function () {
        this.$emit('search', __assign({}, this.formData));
    };
    DetailHeader.prototype.reset = function () {
        this.formData = __assign({}, initFormData);
        this.formData.warning_id = '';
    };
    __decorate([
        Watch('formData.organ_id')
    ], DetailHeader.prototype, "watchFormDataOrganId", null);
    DetailHeader = __decorate([
        Component
    ], DetailHeader);
    return DetailHeader;
}(Vue));
export default DetailHeader;
